// extracted by mini-css-extract-plugin
export default {"container":"copy_container__zY7GI","copied":"copy_copied__UCab6","open":"copy_open__uPUbH"};